"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _App = _interopRequireDefault(require("./App"));

if (typeof require === 'function') {
  require.context('bender-url!../img', true);
}

new _App.default().start();